var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequisitionActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.5V19.0969C14.2489 19.2215 14.2792 19.3444 14.3382 19.4542C14.3972 19.564 14.483 19.6572 14.5875 19.725L15.6188 20.4094C15.7187 20.4761 15.8331 20.5178 15.9525 20.531C16.0719 20.5443 16.1928 20.5287 16.3049 20.4855C16.4169 20.4423 16.517 20.3728 16.5967 20.2829C16.6763 20.193 16.7332 20.0852 16.7625 19.9688L18 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.0007C18.9946 15.0007 19.9484 14.6056 20.6517 13.9023C21.3549 13.1991 21.75 12.2453 21.75 11.2507C21.75 10.2561 21.3549 9.30231 20.6517 8.59905C19.9484 7.89579 18.9946 7.5007 18 7.5007H14.25C14.25 7.5007 9.14062 7.5007 4.22812 3.38507C4.11886 3.29465 3.9862 3.23707 3.84553 3.219C3.70486 3.20093 3.56195 3.22312 3.43338 3.28299C3.30481 3.34286 3.19585 3.43795 3.11914 3.55724C3.04244 3.67653 3.00112 3.81513 3 3.95695V18.5444C3.00112 18.6863 3.04244 18.8249 3.11914 18.9442C3.19585 19.0634 3.30481 19.1585 3.43338 19.2184C3.56195 19.2783 3.70486 19.3005 3.84553 19.2824C3.9862 19.2643 4.11886 19.2067 4.22812 19.1163C9.14062 15.0007 14.25 15.0007 14.25 15.0007H18Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequisitionActive);
export default __webpack_public_path__ + "static/media/requisition_active.acab1a53532e28f2f579e34b6522758e.svg";
export { ForwardRef as ReactComponent };